import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions';
// * 表示将 './actions'模块中的所有接口挂载到actions对象上  as 表示别名的意思
import * as mutations from './mutations'
import * as getters from './getters'
import state from './rootState'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins:[
    //持久化store
    createPersistedState({
      storage: window.localStorage,
      reducer(val) {
        return {
          userInfo : val.userInfo, //储存state中的userInfo
          areaOrgs : val.areaOrgs,
          routers : val.routers,
          loginBy: val.loginBy,
          userSetting: val.userSetting,
        }
      }
    })
  ]
})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js